<template>
<div>
  <h4 class="is-size-4">{{ standard.name }}</h4>

  <markdown class="content" :source="standard.description"/>

  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Section</th>
        <th>Checkpoints</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(section) in standard.sections" :key="section.id">
        <td>
          <router-link 
            :to="{
              name: 'section-manager',
              params: {
                standard: $route.params.standard,
                section: section.id,
              }
            }">
            {{ section.title }}
          </router-link>
        </td>
        <td>
          {{ section.checkpoints.length }}
        </td>
      </tr>
    </tbody>
  </table>


</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters('standard', [
      'standard'
    ])
  }

}
</script>